import { create } from "zustand";

export type SearchState<Item> = {
  searchTerm: string;
  searchResults: Item[];
  isSearching: boolean;
  setSearchTerm: (term: string) => void;
  setSearchResults: (searchResults: Item[]) => void;
  setIsSearching: (isSearching: boolean) => void;
  clearSearch: () => void;
};

const useSearchStateBase = create<SearchState<unknown>>((set) => ({
  searchTerm: "",
  searchResults: [],
  isSearching: false,
  setSearchTerm: (searchTerm) =>
    set(() => ({
      searchTerm,
    })),
  setSearchResults: (searchResults) =>
    set(() => ({
      searchResults,
    })),
  setIsSearching: (isSearching) =>
    set(() => ({
      isSearching,
    })),
  clearSearch: () =>
    set(() => ({
      searchResults: [],
      searchTerm: "",
      isSearching: false,
    })),
}));

export const useSearchState = useSearchStateBase as {
  <T>(): SearchState<T>;
  <T, U>(selector: (s: SearchState<T>) => U): U;
};
